<template>
  <AgentLayout>
    <div>
      <div class="flex items-center gap-3 mb-12">
        <h1 class="block text-2xl font-bold leading-6 text-gray-900">Pipeline Review</h1>
        <Badge
          v-if="reviewData?.pipeline_review"
          :variant="LATENESS_BADGE[reviewData.pipeline_review.lateness].variant"
        >
          {{ LATENESS_BADGE[reviewData.pipeline_review.lateness].text }}
        </Badge>
      </div>

      <HFetchQuery :query="reviewQuery">
        <template #default="{ data: agentPipeline }">
          <ZeroState v-if="unansweredCount(agentPipeline) === 0">
            <p class="font-bold text-gray-800">You're all caught up</p>
            <p class="mt-2 text-gray-600">You have no pending pipeline review questions to answer right now.</p>
          </ZeroState>
          <ReviewAnswerForm v-else class="mt-6" :agent-pipeline="agentPipeline" @answered="reviewQuery.reload" />
        </template>
      </HFetchQuery>
    </div>
  </AgentLayout>
</template>

<script setup lang="ts">
import AgentLayout from '@/components/layouts/AgentLayout/index.vue';
import HFetchQuery from '@/lib/hfetch/HFetchQuery.vue';
import { useHFetchQuery } from '@/lib/hfetch/useHFetchQuery';
import { Api } from '@/api';
import ZeroState from '@/components/ZeroState.vue';
import ReviewAnswerForm from '@/components/agent/pipeline_review/ReviewAnswerForm.vue';
import { Badge, type BadgeVariants } from '@/components/ui/badge';
import type { AgentPipelineReviewResponse } from '@/api/agent/pipeline_review';
import type { PipelineReviewLateness } from '@/api/entity_types/PipelineReview';

const reviewQuery = useHFetchQuery(() => Api.AgentPipelineReview.getCurrentPipelineReview());
const { data: reviewData } = reviewQuery;

const unansweredCount = (agentPipeline: AgentPipelineReviewResponse) =>
  agentPipeline.questions_with_answers.filter(qa => !qa.answer).length;

const LATENESS_BADGE: Record<PipelineReviewLateness, { text: string; variant: BadgeVariants['variant'] }> = {
  today: { text: 'Assigned today', variant: 'gray' },
  one_day_ago: { text: 'Assigned yesterday', variant: 'gray' },
  two_days_ago: { text: 'Assigned 2 days ago', variant: 'gray' },
  three_days_ago: { text: 'Assigned 3 days ago', variant: 'gray' },
  four_days_ago: { text: 'Assigned 4 days ago', variant: 'gray' },
  late: { text: 'Late', variant: 'red' },
};
</script>
